import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight, Lock, Ticket } from "lucide-react";
import { PlanetLogo } from "@/components/PlanetLogo";
import { GlowCard } from "@/components/GlowCard";
import { SiteFooter } from "@/components/SiteFooter";
import { TICKETS } from "@/content/galaxy";

export default function Anmeldung() {
  return (
    <div className="relative min-h-screen overflow-hidden" data-testid="anmeldung-closed-page">
      <div className="relative z-20">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-4 sm:px-6">
          <Link to="/" data-testid="anmeldung-logo-link" className="flex items-center gap-2">
            <PlanetLogo />
            <span className="font-display text-sm font-bold tracking-[0.14em] text-white">
              GALAXY <span className="text-gl-blue2">LEAGUE</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="anmeldung-back-link"
            className="inline-flex items-center gap-2 text-xs tracking-[0.16em] text-white/65 transition-colors hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" />
            ZURÜCK
          </Link>
        </div>
      </div>

      <section className="hero-glow relative">
        <div className="mx-auto max-w-2xl px-4 pb-24 pt-12 sm:px-6 sm:pt-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <GlowCard className="px-6 py-12 text-center sm:px-12 sm:py-16">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-white/12 bg-black/40 text-white/70">
                <Lock className="h-6 w-6" />
              </span>
              <span className="mt-6 inline-flex items-center rounded-full border border-gl-blue/40 bg-gl-blue/10 px-4 py-1.5 font-mono-accent text-[11px] font-semibold tracking-[0.2em] text-gl-blue2">
                TEAM-BEWERBUNG
              </span>
              <h1
                data-testid="anmeldung-closed-title"
                className="mt-6 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-5xl"
              >
                Anmeldung <span className="text-gradient-brand">geschlossen.</span>
              </h1>
              <p className="mx-auto mt-5 max-w-md text-sm leading-relaxed text-white/70 sm:text-base">
                Danke für alle Bewerbungen – die Teams stehen fest. Jetzt beginnt der Ticketverkauf:
                Sichere dir dein Early-Bird-Ticket und erlebe die Galaxy League live in der
                neuro.io Arena Wien.
              </p>
              <a
                href={TICKETS.url}
                data-testid="anmeldung-tickets-button"
                className="group mt-9 inline-flex items-center justify-center gap-2.5 rounded-full bg-brand-gradient px-9 py-4 text-sm font-semibold tracking-wide text-white glow-md transition-[filter,transform] duration-200 hover:-translate-y-0.5 hover:brightness-110 active:scale-[0.98] sm:text-base"
              >
                <Ticket className="h-5 w-5" />
                {TICKETS.cta}
                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
              </a>
              <p className="mt-4 font-mono-accent text-[10px] uppercase tracking-[0.24em] text-white/45">
                Early Bird · nur für kurze Zeit
              </p>
            </GlowCard>
          </motion.div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
